import React from 'react'
import Image from '@toasttab/shared/src/components/atoms/Image/Image'
import { Button, Heading } from '@toasttab/shared/src/components'
import { ContentfulImageAPI } from '@toasttab/shared/src/utils/contentfulUtils'
import { ProductCTAProps } from '../ProductCTA/ProductCTA.d'

const ProductCTA = ({ ctaLink, ctaText, image, heading }: ProductCTAProps) => {
  const imgQuery = ContentfulImageAPI.transformImageAvif()

  return (
    <section className='bg-gray-0 rounded-lg md:shadow-floating flex flex-col md:flex-row mb-10 py-8 px-6 md:py-14 md:px-8'>
      <Image
        url={`${image.file.url}${imgQuery}`}
        classes='w-full md:max-w-[259px] mr-8'
      />
      <div className='flex flex-col justify-center'>
        <Heading
          allowHtml
          classes='mt-4 md:mt-0 mb-4 text-center md:text-left !font-effra !text-[26px] md:!text-[31px]'
          color={['text-black']}
          content={heading}
          fontWeight='font-semibold'
          heading='h3'
          leading={null}
        />
        <div>
          <Button
            fontWeight={['font-semibold']}
            href={ctaLink}
            size='medium'
            variation='secondary-otl'
          >
            {ctaText}
          </Button>
        </div>
      </div>
    </section>
  )
}

export default ProductCTA
